
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class TheBox extends Vue {
  @Prop() content!: string;
  @Prop() icon!: string;
  @Prop({ default: "#226ce0" }) fill!: string;
}
